import { Component, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import Swal from 'sweetalert2';

import { Observable } from 'rxjs';

import { LanguageServiceService } from '../../../../services/language-service.service';
import { DatePipe, formatDate, Location } from '@angular/common';


import * as Tesseract from 'tesseract.js'
import { DeviceDetectorService } from '../../../../services/device-detector.service';

import { HomeService } from '../../../../services/home.service';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { users } from '../../../../interfaces/users';
import e from 'express';
import { EmployeesService } from '../../../../services/employees';
import { ResigteringService } from '../../../Authentication/auth/resigtering.service';

@Component({
  selector: 'app-addemployee',
  templateUrl: './addemployee.component.html',
  styleUrl: './addemployee.component.scss'
})
export class AddemployeeComponent {

  name!: string;
  job_title!: string;
  salary!: string;
  national_id!: string;
  phone!: string;
  address!: string;
  contentReady: boolean = false;
  employeeId!: string;
  hasToken: boolean = false;
  data!: FormGroup;
  selectedProductsDetails: users[] = [];
  productname: users[] = [];
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;
  providers = new FormControl();
  filteredProviders: any[] = this.productname;
  selectedUsers!: any;
  itemData!: any;
  isUpdatePage = false;
  locationById: any;
  text: any;
  isMobile: boolean = false;
  isAr: boolean = false;
  createOrderByid!: any;
  users!: any;
  userLastNamesFromUrl: string[] = [];
  warehouses!: any;
  warehouseId!: string;
  formInfo!: FormGroup;
  systemAccess: boolean = false; // New property to track system access
  constructor(
    private router: Router,
    private _homeService: HomeService,
    private _employee: EmployeesService,
    private fb: FormBuilder,
    private deviceService: DeviceDetectorService,
    private _ResigteringService: ResigteringService,
    private route: ActivatedRoute
  ) { }

  token = localStorage.getItem('token');
  ngOnInit() {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") == "ar";
    this.initiate();


    this.route.queryParams.subscribe(params => {
      if (params["id"] != null) {
        this.isUpdatePage = true;
        this.employeeId = params["id"];
        this.name = params["name"] || '';
        this.job_title = params["job_title"] || '';
        this.salary = params["salary"] || '';
        this.national_id = params["national_id"] || '';
        this.phone = params["phone"] || '';
        this.address = params["address"] || '';
        this.warehouseId = params["warehouse_id"] || null;
      }
    });
    this.formInfo = this.fb.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      phone: ['', [Validators.required, Validators.pattern(`^\\d{11}$`)]],
      systemAccess: [false]
    });
  }

  initiate() {
    this.data = this.fb.group({
      name: ['', Validators.required],
      job_title: ['', Validators.required],
      salary: ['', Validators.required],
      national_id: [''],
      phone: [''],
      address: ['']
    });
  }



  dataForm: any;
  appendPostDtata() {
    this.dataForm = new FormData();
    this.dataForm.append('name', this.name);
    this.dataForm.append('job_title', this.job_title);
    this.dataForm.append('salary', this.salary);
    this.dataForm.append('national_id', this.national_id);
    this.dataForm.append('phone', this.phone);
    this.dataForm.append('address', this.address);

  }

  onSubmit() {
    this.contentReady = true;
    this.appendPostDtata();
    if (this.isUpdatePage)
      this.onEdit();
    else
      this.makeTheEmployeeUser()
  }
  onAdd() {
    this._employee.createEmployee(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم انشاء مواظف " : 'employee created',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;

        if (this.isMobile)
          this.router.navigateByUrl('/employeepage.mobile');
        this.router.navigateByUrl('/allemployees');
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل حفط المواظف" : 'employee not created',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });

        this.contentReady = false;

      },
    });
  }
  onEdit() {
    this._employee.editEmployee(this.dataForm, this.employeeId).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل  المواظف" : 'employee edited',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;

        if (this.isMobile)
          this.router.navigateByUrl('/employeepage.mobile');
        this.router.navigateByUrl('/allemployees');
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل تعديل المواظف" : 'employee not edited',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });

        this.contentReady = false;

      },
    });
  }

  onProductSelected(event: MatSelectChange) {
    var selectedItems;
    if (event.value) {
      selectedItems = event.value;
    }
    else {

      selectedItems = event;
    }
    this.selectedUsers = selectedItems


    console.log(this.selectedUsers);
  }
  getAllUsers() {
    this.contentReady = true;

    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.productname = data.sort((a: any, b: any) =>
          a.last_name.localeCompare(b.last_name, 'ar', { sensitivity: 'base' })
        );

        this.filteredProviders = this.productname;
        this.contentReady = false;
      },
      error: (error) => console.error(error),
    });
  }
  makeTheEmployeeUser() {
    const formData = new FormData();
    const fv = this.formInfo.value;
    // Append form fields to the FormData object
    formData.append('first_name', this.name ?? '');
    formData.append('last_name', this.name ?? '');
    formData.append('instagram_link', '');
    formData.append('facebook_link', '');
    formData.append('tiktok_link', '');
    formData.append('username', this.phone ?? '');
    formData.append('password', this.phone ?? '');
    formData.append('password_confirmation', this.phone ?? '');
    formData.append('phone', this.phone ?? '');
    
    if (this.systemAccess)
      formData.append('type', "6");
    else
      formData.append('type', "7");


    this._ResigteringService.user_Resigter(formData).subscribe({
      next: (res) => {
        this.contentReady = false;
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم انشاء الحساب" : 'user added successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.onAdd();
        const fv = this.formInfo.value!;
        const redirectUrl = this.isMobile ? '/employeepage.mobile' : '/allemployees';
        this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
        this.contentReady = false;

        Swal.fire({
          icon: 'error',
          title: this.isAr ? "  حصل مشكلة في انشاء المستخدم " : 'error while adding this user',
          text: this.isAr ? 'كلم الدعم' : 'you have to contact us',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });

      },
    });

  }
}
